export const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      services: 'Hizmetler',
      apps: 'Uygulamalar',
      testimonials: 'Yorumlar',
      contact: 'İletişime Geç',
      modeNeo: 'Neo',
      modeClassic: 'Klasik'
    },
    hero: {
      badgeWords: [
        'Yenilikçi Dijital Dönüşüm',
        'Modern Web Çözümleri',
        'Android Uygulama Geliştirme',
        'Özel Kurumsal Yazılımlar',
        'UI / UX Tasarımı'
      ],
      titleP1: 'Geleceğin',
      titleHighlight: 'Teknolojisini',
      titleP2: 'Bugünden Şekillendiriyoruz',
      subtitle: 'Akinevo; insan odaklı teknolojiyi, estetik tasarımı ve yüksek performansı bir araya getirerek web ve mobil dünyasında benzersiz dijital deneyimler üretir.',
      exploreBtn: 'Çözümlerimizi Keşfedin',
      contactBtn: 'Bizimle İletişime Geçin',
      statFounded: 'Kuruluş Yılı',
      statQuality: 'Yerli & Özgün Kodlama',
      statServices: 'Hizmet Alanı',
      statSupport: 'Teknik İletişim',
      classicHeadline: 'Geleceğin Teknolojisini Bugünden Şekillendiriyoruz',
      classicDesc: '2025 yılında kurulan Akinevo; mobil uygulama, modern web geliştirme ve kullanıcı odaklı dijital çözümler sunar.',
      marqueeWeb: 'Modern Web Geliştirme',
      marqueeAndroid: 'Android Uygulama',
      marqueeUI: 'UI / UX Deneyim Tasarımı',
      marqueeCustom: 'Özel Kurumsal Panel',
      marqueeSEO: 'Performans & SEO Altyapısı',
      marqueeSecurity: 'Yüksek Güvenlik & Bulut',
      marqueeNative: 'Yerli & Özgün Kodlama'
    },
    about: {
      badge: 'Bizi Tanıyın',
      title: 'Akinevo Hakkında',
      subtitle: 'İnsan odaklı teknolojiyi estetik ve inovasyonla harmanlayarak dijital dünyada fark yaratan bir ekosistem inşa ediyoruz.',
      visionTag: 'Global Dijital Vizyon',
      mainTitle: 'Geleceğin Dijital Deneyimlerini Şekillendiriyoruz',
      p1: 'Akinevo, 2025 yılında kurulan ve teknolojiyi sadece bir araç değil, yaşam kalitesini artıran ve sınırları aşan bir güç olarak benimseyen dinamik bir teknoloji şirketidir.',
      p2: 'Yazılım, sağlık, kişisel gelişim, üretim ve eğlence alanlarında yenilikçi çözümler geliştirerek, kullanıcı deneyimlerini zenginleştiriyor ve sektörel dönüşüme öncülük ediyoruz.',
      p3: 'Ekibimiz tutku, yaratıcılık ve teknik uzmanlığı bir araya getirerek, projelere estetik ile fonksiyonelliği mükemmel bir uyum içinde yansıtan çözümler sunar.',
      v1: 'Sürekli Öğrenme ve Gelişim',
      v2: 'Yüksek Kalite & Güvenilirlik',
      v3: 'İnovasyon ve Yerli Üretim',
      v4: 'Kullanıcı Odaklı Deneyim',
      side1Title: 'Uçtan Uca Yazılım Geliştirme',
      side1Desc: 'Fikir aşamasından yayına kadar modern mimariler, temiz kod standartları ve en son teknolojilerle sürdürülebilir ürünler geliştiriyoruz.',
      side2Title: 'Sağlık & Yaşam Çözümleri',
      side2Desc: 'SacredLifeX gibi öncü ürünlerimizle insanların günlük alışkanlıklarını, uyku kalitelerini ve zindeliklerini iyileştirmeye odaklanıyoruz.',
      side3Title: 'Şeffaf & Güçlü İş Birlikleri',
      side3Desc: 'Tüm süreçlerimizde açık iletişimi, düzeni ve adaletli iş modellerini temel alarak kalıcı ilişkiler inşa ediyoruz.'
    },
    visionMission: {
      badge: 'Gelecek Perspektifimiz',
      title: 'Vizyon & Misyon',
      subtitle: 'Hedeflerimize emin adımlarla ilerlerken, değerlerimizden ve toplumsal fayda odağımızdan ödün vermiyoruz.',
      visionTitle: 'Vizyonumuz',
      visionDesc: 'Yenilikçi teknolojilerle sınırları aşarak dijital dünyada küresel ölçekte ilham veren ve güven duyulan öncü bir teknoloji ekosistemi olmak.',
      missionTitle: 'Misyonumuz',
      missionDesc: 'Kullanıcılarımızın hayatını kolaylaştıran, performansı yüksek, estetik ve güvenilir yazılım çözümleri üreterek dijital dönüşüme yön vermek.',
      f1: 'İnsan ve Değer Odaklılık',
      f2: 'Sürekli İnovasyon ve Ar-Ge',
      f3: 'Küresel Standartlarda Kalite',
      f4: 'Sürdürülebilir & Güvenli Altyapı'
    },
    services: {
      badge: 'Neler Yapıyoruz?',
      title: 'Hizmetlerimiz',
      subtitle: 'Modern standartlarda, yüksek performanslı ve geleceğe hazır yazılım ve teknoloji çözümleri sunuyoruz.',
      filterAll: 'Tüm Hizmetler',
      filterDev: 'Web & Özel Yazılım',
      filterMobile: 'Mobil Uygulama',
      filterConsulting: 'Sistem & Entegrasyon',
      s1Title: 'Modern & Hızlı Web Siteleri',
      s1Badge: 'Ultra Hızlı & SEO',
      s1Desc: 'Şirketinizi veya kişisel markanızı en iyi şekilde yansıtan, tüm cihazlarda kusursuz çalışan, modern ve arama motorlarında (SEO) üst sıralara çıkan web siteleri tasarlıyoruz.',
      s1F1: 'Mobil Uyumlu & Responsive Tasarım',
      s1F2: 'Yüksek Hız ve Google SEO Uyumluluğu',
      s1F3: 'Modern, Şık ve Kullanıcı Dostu Arayüzler',
      s2Title: 'Android Uygulama Geliştirme',
      s2Badge: 'Android & Google Play',
      s2Desc: 'Google Play Store ve Android ekosistemi için hızlı, stabil, kullanıcı dostu ve şık mobil uygulamalar geliştiriyoruz.',
      s2F1: 'Android Cihazlarla Tam Uyum & Yüksek Performans',
      s2F2: 'Kolay Kullanılabilir Sezgisel UI/UX Tasarımı',
      s2F3: 'Bildirim ve Çevrimiçi Çalışma Desteği',
      s3Title: 'Kişiye & İşe Özel Yazılım Çözümleri',
      s3Badge: 'Özel Çözümler',
      s3Desc: 'İşinize özel ihtiyaç duyduğunuz iş mantıklarını, özel veri akışlarını ve süreçlerinizi kolaylaştıracak yazılımları sıfırdan hayata geçiriyoruz.',
      s3F1: 'İhtiyaca Özel Hazırlanan Yazılım Mimarisi',
      s3F2: 'Genişletilebilir ve Kolay Yönetilebilir Kod Tabanı',
      s3F3: 'İş Süreçlerinizi Hızlandıran Fonksiyonel Araçlar',
      s4Title: 'Yönetim Panelleri & Dinamik Sistemler',
      s4Badge: 'Yönetim & Kontrol',
      s4Desc: 'İçeriklerinizi, verilerinizi ve müşteri ilişkilerinizi tek bir noktadan kolayca yönetebileceğiniz pratik paneller kurguluyoruz.',
      s4F1: 'Kullanımı Kolay Yönetim (Admin) Arayüzleri',
      s4F2: 'Gelişmiş Filtreleme ve Dinamik Veri Yönetimi',
      s4F3: 'Kullanıcı Yetkilendirme ve Güvenlik',
      s5Title: 'Akıllı Otomasyon & Entegrasyonlar',
      s5Badge: 'Pratik Çözümler',
      s5Desc: 'Günlük tekrar eden rutin işlerinizi hızlandırmak için akıllı araçlar, bildirim botları ve yardımcı entegrasyonlar kuruyoruz.',
      s5F1: 'Otomatik Bildirim ve Raporlama Araçları',
      s5F2: 'Harici Sistem ve Servis Entegrasyonları',
      s5F3: 'Zaman Kazandıran Pratik Süreçler',
      s6Title: 'Web & Sistem Bakım Desteği',
      s6Badge: 'Sürekli Destek',
      s6Desc: 'Mevcut web sitelerinizin veya uygulamalarınızın düzenli bakımını yapıyor, hızlandırıyor ve teknik güncellemelerini eksiksiz takip ediyoruz.',
      s6F1: 'Web Sitesi Hız ve Güvenlik İyileştirmeleri',
      s6F2: 'Hata Giderme ve Düzenli Güncelleme Desteği',
      s6F3: 'Süreklilik ve Teknik Sorun Çözümü',
      ctaTitle: 'Projeniz İçin Doğru Çözümü Birlikte Belirleyelim',
      ctaDesc: 'Aklınızdaki fikir veya dijital ihtiyaçlarınız için bizimle iletişime geçebilir, ücretsiz ön değerlendirme talep edebilirsiniz.',
      ctaBtn: 'Hemen İletişime Geçin',
      s1T1: 'Web Tasarım',
      s1T2: 'SEO Uyumlu',
      s1T3: 'Responsive',
      s2T1: 'Android Uygulama',
      s2T2: 'Google Play Store',
      s2T3: 'UI/UX Tasarım',
      s2T4: 'Mobil Geliştirme',
      s3T1: 'Özel Yazılım',
      s3T2: 'API Entegrasyonu',
      s3T3: 'Otomasyon',
      s3T4: 'Veri Yönetimi',
      s4T1: 'Admin Panel',
      s4T2: 'Dashboard',
      s4T3: 'Veri Yönetimi',
      s4T4: 'Kontrol Paneli',
      s5T1: 'Otomasyon',
      s5T2: 'Pratik Araçlar',
      s5T3: 'Entegrasyon',
      s5T4: 'Verimlilik',
      s6T1: 'Teknik Destek',
      s6T2: 'Bakım Onarım',
      s6T3: 'Hızlandırma',
      s6T4: 'Süreklilik'
    },
    apps: {
      badge: 'Ekosistemimiz',
      title: 'Uygulamalarımız & Ürünlerimiz',
      subtitle: 'Kullanıcıların hayatına doğrudan dokunan, modern ve işlevsel dijital ürünler geliştiriyoruz.',
      flagshipBadge: 'Öne Çıkan Ürün',
      flagshipTitle: 'SacredLifeX Uygulaması',
      flagshipDesc: 'Geliştirdiğimiz SacredLifeX uygulaması sayesinde kullanıcılarımız kendilerini sürekli geliştirme imkânı bulurken, eğlenceyi de elden bırakmıyor.',
      crossBadge: 'Çapraz Platform Desteği: Bilgisayar & Telefonlar',
      f1Title: 'Çapraz Platform Deneyimi',
      f1Desc: 'Tüm bilgisayar tarayıcıları ve akıllı telefonlarda kesintisiz erişim',
      f2Title: 'Sağlık & Su Takibi',
      f2Desc: 'Günlük kalori ve su tüketim kontrolü',
      f3Title: 'Diksiyon Geliştirme',
      f3Desc: 'Konuşma ve artikülasyon egzersizleri',
      f4Title: 'Uyku & Zindelik',
      f4Desc: 'Dinlenme döngüleri ve Akıllı Uyku Analizi',
      visitBtn: "SacredLifeX'i Ziyaret Et",
      viewGalleryBtn: 'Tüm Ekranları Görüntüle',
      showcasePill: 'Diğer Ekranları İncele (8 Görsel)',
      pipelineTitle: 'Geliştirme Aşamasındaki Diğer Projeler',
      pipelineBadge: 'Yakında',
      pipelineDesc: 'Ar-Ge merkezimizde üzerinde çalıştığımız yeni nesil dijital projelerimiz.',
      rdTag: 'Ar-Ge Aşaması',
      comingSoonBadge: 'Yakında',
      comingSoonTitle: '...YAKINDA...',
      comingSoonDesc: 'Yeni nesil teknoloji projemiz çok yakında burada duyurulacaktır.'
    },
    gallery: {
      backBtn: 'Ana Sayfaya Dön',
      badge: 'Uygulama Ekranları',
      title: 'SacredLifeX Ekran Galerisi',
      subtitle: 'Uygulamamızın sunduğu kullanıcı dostu arayüzlerin ve detaylı ekran tasarımlarının öne çıkan bazı parçalarını inceleyebilirsiniz.',
      zoomHint: 'Büyütmek İçin Tıklayın'
    },
    process: {
      badge: 'Şeffaf & Profesyonel Süreç',
      title: 'Nasıl Çalışıyoruz?',
      subtitle: 'Sürpriz maliyetler veya gecikmeler olmadan, adım adım planlanan ve şeffaf şekilde yönetilen gerçekçi yazılım geliştirme metodolojimiz.',
      s1Badge: 'Planlama',
      s1Title: 'Gereksinim Analizi & Bütçelendirme',
      s1Desc: 'Projenizin kapsamını, teknik ihtiyaçlarını ve hedeflerinizi detaylıca dinliyoruz. Şeffaf bir zaman planı ve net maliyet tablosu çıkarıyoruz.',
      s1B1: 'Proje ihtiyaç analizi & planlama',
      s1B2: 'En uygun teknoloji altyapısının belirlenmesi',
      s1B3: 'Net teslim tarihi & kilometre taşları',
      s2Badge: 'Tasarım',
      s2Title: 'Modern Arayüz & Kullanıcı Deneyimi Kurgusu',
      s2Desc: 'Projenin amacına en uygun renk paletlerini, okunabilir tipografiyi ve ziyaretçilerin en kolay şekilde gezinebileceği modern sayfa yerleşimlerini kurguluyoruz.',
      s2B1: 'Kullanıcı dostu ve akıcı sayfa düzeni',
      s2B2: 'Modern, şık ve göz yormayan görsel estetik',
      s2B3: 'Tüm cihazlara duyarlı (Responsive) tasarım kurgusu',
      s3Badge: 'Geliştirme',
      s3Title: 'Yazılım Geliştirme & İlerleme Takibi',
      s3Desc: 'Yazılımı modüler adımlarla kodluyor, süreç boyunca gelişmeleri adım adım sizinle gerekli bilgileri paylaşarak şeffaf bir ilerleme sağlıyoruz.',
      s3B1: 'Temiz, hızlı ve güvenli kodlama',
      s3B2: 'Aşama aşama ilerleme ve ara demolar',
      s3B3: 'Düzenli bilgilendirme ve istişare',
      s4Badge: 'Sıfır Hata',
      s4Title: 'Kapsamlı Test & Güvenlik Denetimi',
      s4Desc: 'Yayın öncesinde çapraz cihaz uyumluluğu, güvenlik açıkları, veritabanı yük testleri ve hız optimizasyonları tamamlanır.',
      s4B1: 'Mobil, tablet ve masaüstü uyum testleri',
      s4B2: 'Hız, SEO ve performans optimizasyonu',
      s4B3: 'Güvenlik ve penetrasyon kontrolleri',
      s5Badge: 'Canlıya Geçiş',
      s5Title: 'Sorunsuz Dağıtım & Canlı Yayın',
      s5Desc: 'Domain, SSL, sunucu kurulumu, veri tabanı geçişi ve Google Play Store mağaza yüklemelerini eksiksiz gerçekleştiriyoruz.',
      s5B1: 'Bulut sunucu & SSL yapılandırması',
      s5B2: 'Mağaza yayına alma süreçleri',
      s5B3: 'Eksiksiz veri tabanı geçişi',
      s6Badge: 'Garanti & Destek',
      s6Title: 'Sözleşme Kapsamında Bakım & Destek',
      s6Desc: 'Proje teslimi sonrasında sözleşmemizde belirlenen süre boyunca sistemlerinizi garanti altına alıyor, bakım ve teknik desteği eksiksiz sağlıyoruz.',
      s6B1: 'Sözleşme süresince garanti ve hata düzeltme',
      s6B2: 'Periyodik yedeklemeler ve stabilite takibi',
      s6B3: 'Gereksinimlere göre ek geliştirme desteği'
    },
    testimonials: {
      backBtn: 'Ana Sayfaya Dön',
      badge: 'Güven ve İş Ortaklığı',
      title: 'Müşterilerimiz Ne Diyor?',
      subtitle: 'Projelerini teslim ettiğimiz iş ortaklarımızın ve kullanıcılarımızın deneyimleri bizim en büyük referansımızdır.',
      filterAll: 'Tüm Yorumlar',
      filterWeb: 'Web Yazılım',
      filterMobile: 'Mobil Uygulama',
      filterCustom: 'Özel Çözümler',
      trustDelivery: 'Zamanında Teslimat',
      trustSatisfaction: 'Ortalama Müşteri Memnuniyeti',
      trustSupport: 'Canlı İletişim & Garanti Desteği'
    },
    contact: {
      badge: 'İletişim & Danışmanlık',
      title: 'Bizimle İletişime Geçin',
      subtitle: 'Aklınızdaki projeyi hayata geçirmek veya teknik detayları konuşmak için formu doldurabilir ya da doğrudan bize ulaşabilirsiniz.',
      infoTitle: 'İletişim Bilgileri',
      infoDesc: 'Yeni bir proje başlatmak, mevcut sisteminizi yenilemek veya sadece fikir almak için bize her zaman yazabilirsiniz.',
      emailLabel: 'E-Posta Adresi',
      locationLabel: 'Konum',
      locationVal: 'Sivas, Türkiye',
      mapGlobalBadge: 'Küresel Erişim & Kesintisiz Hizmet',
      mapGlobalTitle: 'İnternetin Olduğu Her Yerdeyiz',
      mapGlobalSubtitle: 'Fiziksel sınırları aşıyor; Türkiye’den dünyaya, dijitalin ve internetin ulaştığı her noktada projeler üretiyoruz.',
      mapModeSatellite: 'Uydu Görünümü',
      mapModeRoad: 'Harita Görünümü',
      hoursLabel: 'Çalışma Saatleri',
      hoursVal: '7/24 Kesintisiz İletişim & Destek',
      guaranteeTitle: 'Gizlilik ve Güvenilirlik',
      guaranteeDesc: 'Paylaştığınız tüm proje detayları ve iletişim bilgileriniz gizlilik prensiplerimiz gereği üçüncü kişilerle paylaşılmaz.',
      formTitle: 'Mesaj Gönderin',
      formDesc: 'Talebinizi iletin, en geç 24 saat içinde detaylı olarak geri dönelim.',
      labelName: 'Adınız Soyadınız',
      placeholderName: 'Örn: Ahmet Yılmaz',
      labelPhone: 'Telefon Numaranız',
      placeholderPhone: 'Örn: 0555 123 45 67',
      labelEmail: 'E-Posta Adresiniz',
      placeholderEmail: 'ahmet@example.com',
      labelSubject: 'Konu Seçimi',
      subWeb: 'Modern Web Sitesi Geliştirme',
      subAndroid: 'Mobil Uygulama Geliştirme (Android)',
      subCustom: 'Kişiye / Şirkete Özel Yazılım',
      subAdmin: 'Yönetim Paneli & Dashboard Kurulumu',
      subAutomation: 'Akıllı Otomasyon & Entegrasyonlar',
      subMaintenance: 'Web & Sistem Bakım Desteği',
      subPerformance: 'Performans & Hız Optimizasyonu',
      subConsulting: 'Genel Teknik Danışmanlık',
      subOther: 'Diğer',
      labelMessage: 'Proje Detayları / Mesajınız',
      placeholderMessage: 'Projenizin kapsamını, aklınızdaki hedefleri veya sormak istediğiniz soruları kısaca özetleyin...',
      btnSend: 'Mesajı Gönder',
      btnSending: 'Gönderiliyor...',
      successTitle: 'Mesajınız Başarıyla İletildi!',
      successDesc: 'Talebinizi aldık. En kısa sürede inceleyip e-posta adresiniz üzerinden sizinle iletişime geçeceğiz.',
      sendNewBtn: 'Yeni Bir Mesaj Gönder',
      errorMsg: 'Mesaj gönderilirken bir hata oluştu. Lütfen doğrudan akinevo0@gmail.com adresinden iletişime geçiniz.'
    },
    footer: {
      desc: '2025 yılında kurulan Akinevo; insan odaklı teknolojiyi, mobil deneyimleri ve modern web yazılım çözümlerini harmanlayarak dijital dünyada kalıcı değerler üretir.',
      quickLinks: 'Hızlı Bağlantılar',
      servicesTitle: 'Hizmetlerimiz',
      contactTitle: 'İletişim',
      privacyPolicy: 'Gizlilik Politikası',
      termsOfUse: 'Kullanım Koşulları',
      copyright: 'Tüm hakları saklıdır.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      apps: 'Applications',
      testimonials: 'Testimonials',
      contact: 'Get In Touch',
      modeNeo: 'Neo',
      modeClassic: 'Classic'
    },
    hero: {
      badgeWords: [
        'Innovative Digital Transformation',
        'Modern Web Solutions',
        'Android App Engineering',
        'Custom Enterprise Software',
        'UI / UX Design'
      ],
      titleP1: 'Shaping the',
      titleHighlight: 'Technology',
      titleP2: 'of the Future, Today',
      subtitle: 'Akinevo combines human-centric technology, aesthetic design, and high performance to build exceptional digital experiences in the web and mobile worlds.',
      exploreBtn: 'Explore Our Solutions',
      contactBtn: 'Get In Touch With Us',
      statFounded: 'Founded In',
      statQuality: 'Native & Original Code',
      statServices: 'Service Fields',
      statSupport: 'Technical Support',
      classicHeadline: 'Shaping the Technology of the Future, Today',
      classicDesc: 'Founded in 2025, Akinevo provides mobile applications, modern web development, and user-centric digital solutions.',
      marqueeWeb: 'Modern Web Engineering',
      marqueeAndroid: 'Android Native Apps',
      marqueeUI: 'UI / UX Product Design',
      marqueeCustom: 'Custom Enterprise Panels',
      marqueeSEO: 'Speed & SEO Optimization',
      marqueeSecurity: 'Cloud & Cyber Security',
      marqueeNative: 'Original & Proprietary Code'
    },
    about: {
      badge: 'Discover Us',
      title: 'About Akinevo',
      subtitle: 'Blending human-centric technology with aesthetics and innovation, we build an ecosystem that creates real impact in the digital landscape.',
      visionTag: 'Global Digital Vision',
      mainTitle: 'Crafting the Digital Experiences of Tomorrow',
      p1: 'Founded in 2025, Akinevo is a dynamic technology company that embraces technology not just as an instrument, but as an empowering force that enriches quality of life and transcends boundaries.',
      p2: 'By developing state-of-the-art solutions across software, health, personal growth, manufacturing, and entertainment, we enrich user experiences and spearhead sectoral evolution.',
      p3: 'Our team harmonizes passion, creativity, and technical prowess to deliver solutions that seamlessly unite elegance with practical functionality.',
      v1: 'Continuous Learning & Growth',
      v2: 'Top-tier Quality & Reliability',
      v3: 'Innovation & Local Craftsmanship',
      v4: 'Human-Centric User Experience',
      side1Title: 'End-to-End Software Development',
      side1Desc: 'From initial ideation to public launch, we engineer sustainable products built on modern architectures, pristine code, and cutting-edge technologies.',
      side2Title: 'Health & Lifestyle Innovations',
      side2Desc: 'Through flagship products like SacredLifeX, we focus on enhancing daily habits, sleep hygiene, and overall vitality.',
      side3Title: 'Transparent & Lasting Partnerships',
      side3Desc: 'We cultivate dependable partnerships grounded in candid communication, meticulous structure, and equitable business ethics.'
    },
    visionMission: {
      badge: 'Future Perspective',
      title: 'Vision & Mission',
      subtitle: 'Steadfast in pursuing ambitious milestones without ever compromising our ethical values and community-first principles.',
      visionTitle: 'Our Vision',
      visionDesc: 'To be a trailblazing technology ecosystem that inspires global trust and pioneers breakthrough digital solutions.',
      missionTitle: 'Our Mission',
      missionDesc: 'To guide digital transformation by creating high-performance, aesthetic, and dependable software solutions that elevate everyday life.',
      f1: 'Human & Value Centricity',
      f2: 'Continuous Innovation & R&D',
      f3: 'World-Class Quality Standards',
      f4: 'Sustainable & Fortified Architecture'
    },
    services: {
      badge: 'What We Deliver',
      title: 'Our Services',
      subtitle: 'Delivering modern, high-performance, and future-ready software and technology solutions.',
      filterAll: 'All Services',
      filterDev: 'Web & Custom Dev',
      filterMobile: 'Mobile Apps',
      filterConsulting: 'Systems & Integrations',
      s1Title: 'Modern & High-Speed Websites',
      s1Badge: 'Ultra Fast & SEO',
      s1Desc: 'We engineer websites that represent your corporate or personal brand with distinction, perform flawlessly across all screen sizes, and achieve top SEO rankings.',
      s1F1: 'Fully Responsive & Mobile-Optimized Design',
      s1F2: 'Exceptional Speed & Google SEO Synergy',
      s1F3: 'Contemporary, Sleek & Intuitive Interfaces',
      s2Title: 'Android Application Engineering',
      s2Badge: 'Android & Google Play',
      s2Desc: 'We engineer robust, responsive, user-friendly, and visually engaging mobile applications tailored for Google Play and the Android ecosystem.',
      s2F1: 'Full Android Ecosystem Harmony & High Performance',
      s2F2: 'Intuitive, Ergonomic UI/UX Design',
      s2F3: 'Push Notifications & Online Service Support',
      s3Title: 'Tailor-Made Bespoke Software Solutions',
      s3Badge: 'Custom Solutions',
      s3Desc: 'We bring custom operational workflows, bespoke data pipelines, and productivity-enhancing software to life from the ground up.',
      s3F1: 'Purpose-Built Software Architecture',
      s3F2: 'Extensible & Maintainable Codebase',
      s3F3: 'Productivity Tools Accelerating Your Operations',
      s4Title: 'Admin Dashboards & Dynamic Systems',
      s4Badge: 'Management & Control',
      s4Desc: 'We design intuitive administrative consoles empowering you to manage content, operations, and customer relationships from a unified control deck.',
      s4F1: 'Effortless & Ergonomic Admin Consoles',
      s4F2: 'Advanced Filtering & Dynamic Data Management',
      s4F3: 'Granular Role-Based Access & Security',
      s5Title: 'Smart Automation & Integrations',
      s5Badge: 'Practical Solutions',
      s5Desc: 'We set up intelligent bots, automated notification triggers, and auxiliary integrations to streamline recurring day-to-day operations.',
      s5F1: 'Automated Dispatch & Analytics Reporting',
      s5F2: 'External Systems & API Service Bridges',
      s5F3: 'Time-Saving Optimized Workflows',
      s6Title: 'Web & Infrastructure Maintenance',
      s6Badge: 'Continuous Support',
      s6Desc: 'We perform regular health audits, performance tuning, and comprehensive security updates for your live websites and software.',
      s6F1: 'Speed Optimization & Security Hardening',
      s6F2: 'Bug Remediation & Scheduled Upgrades',
      s6F3: 'High Availability & Technical Problem Resolution',
      ctaTitle: "Let's Define the Optimal Solution for Your Project",
      ctaDesc: 'Reach out to discuss your digital ambitions or software needs, and request a complimentary preliminary evaluation.',
      ctaBtn: 'Contact Us Now',
      s1T1: 'Web Design',
      s1T2: 'SEO Friendly',
      s1T3: 'Responsive',
      s2T1: 'Android App',
      s2T2: 'Google Play Store',
      s2T3: 'UI/UX Design',
      s2T4: 'Mobile Dev',
      s3T1: 'Bespoke Software',
      s3T2: 'API Integration',
      s3T3: 'Automation',
      s3T4: 'Data Management',
      s4T1: 'Admin Panel',
      s4T2: 'Dashboard',
      s4T3: 'Data Management',
      s4T4: 'Control Panel',
      s5T1: 'Automation',
      s5T2: 'Practical Tools',
      s5T3: 'Integration',
      s5T4: 'Efficiency',
      s6T1: 'Technical Support',
      s6T2: 'Maintenance',
      s6T3: 'Acceleration',
      s6T4: 'Continuity'
    },
    apps: {
      badge: 'Our Ecosystem',
      title: 'Our Applications & Products',
      subtitle: 'We craft practical and stylish digital products that directly enrich everyday living.',
      flagshipBadge: 'Featured Product',
      flagshipTitle: 'SacredLifeX Application',
      flagshipDesc: 'Through our flagship SacredLifeX app, users unlock consistent personal development while enjoying a rewarding and engaging experience.',
      crossBadge: 'Cross-Platform Experience: Desktop & Mobile Devices',
      f1Title: 'Cross-Platform Flexibility',
      f1Desc: 'Uninterrupted accessibility across desktop web browsers and smartphones',
      f2Title: 'Hydration & Health Journaling',
      f2Desc: 'Daily caloric intake and comprehensive water tracking',
      f3Title: 'Diction Mastery Modules',
      f3Desc: 'Vocal articulation exercises and clarity drills',
      f4Title: 'Sleep & Vitality Analytics',
      f4Desc: 'Rest cycle monitoring with Intelligent Sleep Coaching',
      visitBtn: 'Visit SacredLifeX',
      viewGalleryBtn: 'View All Screenshots',
      showcasePill: 'Explore Other Screens (8 Views)',
      pipelineTitle: 'Upcoming Pipeline Projects',
      pipelineBadge: 'Soon',
      pipelineDesc: 'Next-generation digital projects currently in progress within our R&D hub.',
      rdTag: 'R&D Phase',
      comingSoonBadge: 'Soon',
      comingSoonTitle: '...COMING SOON...',
      comingSoonDesc: 'Our next-generation technology venture will be unveiled here soon.'
    },
    gallery: {
      backBtn: 'Back to Home',
      badge: 'App Screenshots',
      title: 'SacredLifeX Screen Gallery',
      subtitle: 'Explore selected highlights showcasing our intuitive user interfaces and detail-oriented mobile screen designs.',
      zoomHint: 'Click to Enlarge'
    },
    process: {
      badge: 'Transparent & Professional Workflow',
      title: 'How We Work',
      subtitle: 'Our realistic software development lifecycle is orchestrated step by step with complete transparency—eliminating unforeseen costs and delays.',
      s1Badge: 'Planning',
      s1Title: 'Scope Analysis & Transparent Budgeting',
      s1Desc: 'We carefully examine your project requirements, technical prerequisites, and milestones to provide a transparent timeline and defined roadmap.',
      s1B1: 'Project requirements breakdown & planning',
      s1B2: 'Identification of the ideal technology stack',
      s1B3: 'Clear delivery schedule & milestones',
      s2Badge: 'Design',
      s2Title: 'Modern UI & Experience Architecture',
      s2Desc: 'We curate bespoke color harmony, legible typography, and intuitive page layouts tailored specifically to maximize user comfort and engagement.',
      s2B1: 'Ergonomic, user-friendly page hierarchy',
      s2B2: 'Modern, elegant and eye-soothing visual appeal',
      s2B3: 'Fully responsive cross-device layout design',
      s3Badge: 'Development',
      s3Title: 'Software Engineering & Progress Tracking',
      s3Desc: 'We engineer software in modular phases, sharing milestone progress and vital updates transparently at every stage.',
      s3B1: 'Pristine, performant and secure code',
      s3B2: 'Step-by-step progress tracking & interim demos',
      s3B3: 'Regular consultations & status briefings',
      s4Badge: 'Zero Defect',
      s4Title: 'Rigorous Testing & Security Verification',
      s4Desc: 'Before deployment, comprehensive cross-device compatibility, security scans, database load verification, and speed benchmarks are finalized.',
      s4B1: 'Mobile, tablet, and desktop fidelity checks',
      s4B2: 'Speed, SEO, and performance optimization',
      s4B3: 'Security audits & vulnerability checks',
      s5Badge: 'Launch',
      s5Title: 'Seamless Deployment & Production Rollout',
      s5Desc: 'We oversee domain routing, SSL certificate setup, cloud server deployment, database migration, and Google Play Store submissions with precision.',
      s5B1: 'Cloud infrastructure & SSL configuration',
      s5B2: 'App store submission and release management',
      s5B3: 'Complete and secure database migration',
      s6Badge: 'Warranty',
      s6Title: 'Contracted Maintenance & Dedicated Support',
      s6Desc: 'Following delivery, we warranty your software throughout the agreed term, providing ongoing maintenance and swift technical assistance.',
      s6B1: 'Warranty coverage and proactive bug remediation',
      s6B2: 'Periodic database backups & uptime monitoring',
      s6B3: 'Iterative feature expansions upon request'
    },
    testimonials: {
      backBtn: 'Back to Home',
      badge: 'Trust & Partnerships',
      title: 'What Our Clients Say',
      subtitle: 'The authentic experiences of our partners and users stand as the cornerstone of our credibility.',
      filterAll: 'All Reviews',
      filterWeb: 'Web Engineering',
      filterMobile: 'Mobile Applications',
      filterCustom: 'Bespoke Systems',
      trustDelivery: 'On-Time Delivery',
      trustSatisfaction: 'Average Client Satisfaction',
      trustSupport: 'Live Communication & Warranty'
    },
    contact: {
      badge: 'Inquiries & Consultation',
      title: 'Get in Touch With Us',
      subtitle: 'To bring your vision to life or discuss technical specifications, submit the contact form or reach out to us directly.',
      infoTitle: 'Contact Details',
      infoDesc: 'Whether you want to initiate a new project, upgrade your existing digital ecosystem, or explore concepts, we are always eager to connect.',
      emailLabel: 'Email Address',
      locationLabel: 'Location',
      locationVal: 'Sivas, Turkey',
      mapGlobalBadge: 'Global Reach & Borderless Solutions',
      mapGlobalTitle: 'Everywhere the Internet Reaches',
      mapGlobalSubtitle: 'Transcend physical boundaries — from Turkey to the world, delivering high-impact digital solutions wherever the internet connects.',
      mapModeSatellite: 'Satellite View',
      mapModeRoad: 'Map View',
      hoursLabel: 'Working Hours',
      hoursVal: '24/7 Continuous Support & Operations',
      guaranteeTitle: 'Privacy & Data Protection',
      guaranteeDesc: 'All project information and contact data shared with us remain strictly confidential and will never be disclosed to third parties.',
      formTitle: 'Send a Message',
      formDesc: 'Submit your inquiry and our team will respond within 24 business hours with comprehensive insights.',
      labelName: 'Your Full Name',
      placeholderName: 'e.g. John Doe',
      labelPhone: 'Your Phone Number',
      placeholderPhone: 'e.g. +90 555 123 45 67',
      labelEmail: 'Your Email Address',
      placeholderEmail: 'john@example.com',
      labelSubject: 'Inquiry Subject',
      subWeb: 'Modern Web Engineering',
      subAndroid: 'Android Mobile App Development',
      subCustom: 'Bespoke Corporate Software',
      subAdmin: 'Admin Dashboard & Control Console',
      subAutomation: 'Smart Automation & System Bridges',
      subMaintenance: 'Web & Infrastructure Maintenance',
      subPerformance: 'Speed & Performance Optimization',
      subConsulting: 'General Technical Advisory',
      subOther: 'Other',
      labelMessage: 'Project Overview / Message',
      placeholderMessage: 'Briefly describe your project scope, target goals, or questions...',
      btnSend: 'Send Message',
      btnSending: 'Sending...',
      successTitle: 'Message Delivered Successfully!',
      successDesc: 'We have received your message. Our team will review your inquiry and follow up via email promptly.',
      sendNewBtn: 'Send Another Message',
      errorMsg: 'An error occurred while submitting. Please feel free to email us directly at akinevo0@gmail.com.'
    },
    footer: {
      desc: 'Founded in 2025, Akinevo produces enduring value across the digital frontier by fusing human-centric technology, mobile experiences, and modern web solutions.',
      quickLinks: 'Quick Navigation',
      servicesTitle: 'Our Capabilities',
      contactTitle: 'Reach Out',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Service',
      copyright: 'All rights reserved.'
    }
  }
};
